import { Fulfillment } from "@secondcloset/types";
import { getAPIFromDomain } from "../../lib/api";

interface FetchReturnsQuery {
  organization_id: string;
}

export const fetchReturnsConfiguration = async (
  query: FetchReturnsQuery
): Promise<Fulfillment.ReturnsConfiguration[]> => {
  const api = getAPIFromDomain("fulfillment");
  const res = await api.get("/return_configurations", { params: query });
  return res.data;
};
